///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/report-service-categories.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportServiceCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected serviceCategories: ReportServiceCategoriesCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.serviceCategories;
        }

        constructor(model: Dictionary<any>, properties: string[], options: any) {
            super(model, properties, options);

            this.serviceCategories = new ReportServiceCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.tips = [
                'TIP_NOT_SELECTING_SERVICE_CATEGORY'
            ];
            this.title = 'LABEL_SERVICE_CATEGORY';
            this.allSelectedLabel = 'LABEL_ALL_SERVICE_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICE_CATEGORIES_SELECTED';
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: angular.IQService): angular.IPromise<any> {
            this.serviceCategories.updateCriteria({DepartmentList: newCriteria['DepartmentList'] === null ? null : [newCriteria['DepartmentList']]});
            return this.serviceCategories.fetch();
        }
    }
}
